import React, { Component } from 'react'
// import { storeData } from '../../../storeData'

export default class Envios extends Component {
  render() {
    const {storeData} = this.props
    return (
      <div className='DefaultPage'>
<h2>

Política de envío
</h2>

<h2>

Envíos
</h2>

<p>

Todos los productos ofertados en esta web son importados y hay disponibilidad de los mismos segun el stock existente al momento de la compra. Por lo tanto {storeData.domain} envía tu pedido a la dirección que desees en un tiempo estimado de 5 a 8 días hábiles desde la confirmación del pedido, brindándote cobertura en la mayoría de los municipios de Colombia a través de diferentes transportadoras.
</p>

<h2>

Tiempos de entrega:
</h2>

<p>

La entrega se realizará en la dirección indicada en el momento de la compra a cualquier persona responsable y mayor de edad que se encuentre en el domicilio en el momento de la entrega, para lo cual bastará la firma de la guía del transportador (incluye para unidades residenciales o edificios con servicio de portería, la recepción y firma del portero).
</p>

<p>

El tiempo estimado de entrega para Bogotá es de hasta 2 días hábiles y para el resto del país, entregamos tu pedido en un plazo de hasta 10 días hábiles. 
</p>

<p>

El tiempo de entrega empezará a contar a partir del siguiente día hábil de confirmación de tu compra.
Si realizas una compra un sábado, domingo o un día festivo, el tiempo de entrega empezará a contar a partir del siguiente día hábil de confirmación de tu compra.
Si al momento de recibir tu pedido notas alguna novedad en el empaque o estado del mismo, ésta se debe registrar en el campo de observaciones de la guía de transporte.
</p>

<p>

Las entregas no se pueden realizar en un horario exacto y en caso de que no haya nadie en el domicilio, la transportadora hará hasta dos intentos de entrega adicionales. En caso de no poder realizar la entrega, el producto será devuelto a nuestra bodega y luego de ello, siempre que el pago hubiese sido distinto al método contra entrega, nos pondremos en contacto contigo para acordar un nuevo envío. Recuerda que las compras hechas en {storeData.domain} no pueden retirarse en nuestros puntos de venta, centros de distribución y en general cualquier instalación de {storeData.domain}.
</p>


<h2>

Modalidades de entrega:
</h2>

<p>

Al realizar tu compra en {storeData.domain} a través de Ventas por whatsapp tu pedido se despachara de la siguiente forma
</p>

<h2>

Envío a domicilio
</h2>

<p>

Esta modalidad aplica cuando compras en {storeData.domain} y en ventas por whatsapp. Tus compras serán enviadas a la dirección que desees. El cliente realiza la compra y le enviamos el producto a la dirección donde el cliente lo desee, de acuerdo con las políticas de envío de {storeData.domain}
</p>

<p>

*El vendedor te informará si el producto está disponible para envío a domicilio.
</p>

<p>

Cuando realices compras que deban ser entregadas en la ciudad de Bogotá, el tiempo estimado de entrega es de hasta 2 días hábiles y para el resto del país, en un plazo de hasta 10 días hábiles, en ambos casos es previa confirmación de inventario y se estaría informando al momento de tu compra la fecha estimada de la entrega. Si deseas cambiar la dirección de entrega:
</p>

<p>

El cambio sin costo adicional, se puede solicitar hasta, 2 horas después de confirmada la compra.
Para hacer la solicitud, debes comunicarte con nuestra línea de atención al cliente.
Después de las 2 horas, el cambio tendrá un costo adicional por concepto de flete.
El tiempo de entrega empezará a contar después de confirmar el pago del flete, según tiempo de transito de la ciudad de destino seleccionada.
</p>
      </div>
    )
  }
}
